import React, { useState } from 'react';
import { GripVertical, Edit2, Trash2, Plus } from 'lucide-react';
import './FormBuilder.css';

interface Question {
  id: string;
  type: string;
  text: string;
  required: boolean;
}

const FormBuilder: React.FC = () => {
  const [showAddQuestion, setShowAddQuestion] = useState(false);
  const [questions, setQuestions] = useState<Question[]>([
    { id: '1', type: 'Multiple Choice', text: 'asdsfadgsfhdgjfhjkjl', required: true },
    { id: '2', type: 'Text Response', text: 'how ru', required: true },
  ]);

  return (
    <div className="s-admin-feedback-form-builder">
      <div className="s-admin-feedback-form-builder-layout">
        <div className="s-admin-feedback-builder-main">
          <div className="s-admin-feedback-survey-details-section">
            <h3>Survey Details</h3>

            <div className="s-admin-feedback-form-field">
              <label htmlFor="survey-name">Survey Name</label>
              <input
                type="text"
                id="survey-name"
                placeholder="e.g., Course Feedback Survey"
              />
            </div>

            <div className="s-admin-feedback-form-field">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                rows={3}
                placeholder="Brief description of the survey purpose"
              />
            </div>

            <div className="s-admin-feedback-form-field">
              <label htmlFor="survey-type">Survey Type</label>
              <select id="survey-type">
                <option value="">Select</option>
                <option value="feedback">Feedback</option>
                <option value="satisfaction">Satisfaction</option>
                <option value="assessment">Assessment</option>
              </select>
            </div>
          </div>

          <div className="s-admin-feedback-questions-section">
            <div className="s-admin-feedback-questions-header">
              <h3>Questions ({questions.length})</h3>
              <button className="s-admin-feedback-add-question-btn" onClick={() => setShowAddQuestion(true)}>
                <Plus size={16} />
                Add Question
              </button>
            </div>

            <div className="s-admin-feedback-questions-list">
              {questions.map((question, index) => (
                <div key={question.id} className="s-admin-feedback-question-item">
                  <div className="s-admin-feedback-question-drag">
                    <GripVertical size={16} />
                    <span className="s-admin-feedback-question-number">Q{index + 1}</span>
                  </div>
                  <div className="s-admin-feedback-question-content">
                    <div className="s-admin-feedback-question-text">{question.text}</div>
                    <div className="s-admin-feedback-question-meta">
                      <span className="s-admin-feedback-question-type">{question.type}</span>
                      <span className="s-admin-feedback-question-required">Required</span>
                    </div>
                  </div>
                  <div className="s-admin-feedback-question-actions">
                    <button className="s-admin-feedback-icon-btn">
                      <Edit2 size={16} />
                    </button>
                    <button className="s-admin-feedback-icon-btn s-admin-feedback-icon-btn-delete">
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="s-admin-feedback-form-actions">
              <button className="s-admin-feedback-form-action-btn s-admin-feedback-form-action-btn-secondary">Save as Draft</button>
              <button className="s-admin-feedback-form-action-btn s-admin-feedback-form-action-btn-primary">
                <span>›</span>
                Publish Survey
              </button>
            </div>
          </div>
        </div>

        <div className="s-admin-feedback-builder-preview">
          <div className="s-admin-feedback-preview-header">
            <h4>Preview</h4>
          </div>
          <div className="s-admin-feedback-preview-content">
            {questions.map((question, index) => (
              <div key={question.id} className="s-admin-feedback-preview-question">
                <div className="s-admin-feedback-preview-question-label">
                  {index + 1}. {question.text} {question.required && <span className="s-admin-feedback-required">*</span>}
                </div>
                {question.type === 'Multiple Choice' ? (
                  <div className="s-admin-feedback-preview-options">
                    <label className="s-admin-feedback-preview-option">
                      <input type="checkbox" />
                      <span>Option 1</span>
                    </label>
                    <label className="s-admin-feedback-preview-option">
                      <input type="checkbox" />
                      <span>Option 2</span>
                    </label>
                    <label className="s-admin-feedback-preview-option">
                      <input type="checkbox" />
                      <span>Option 3</span>
                    </label>
                    <label className="s-admin-feedback-preview-option">
                      <input type="checkbox" />
                      <span>Option 4</span>
                    </label>
                  </div>
                ) : (
                  <input
                    type="text"
                    className="s-admin-feedback-preview-text-input"
                    placeholder="Your answer"
                    readOnly
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {showAddQuestion && (
        <div className="s-admin-feedback-modal-overlay" onClick={() => setShowAddQuestion(false)}>
          <div className="s-admin-feedback-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="s-admin-feedback-modal-header">
              <h3>Add Question</h3>
              <button className="s-admin-feedback-close-btn" onClick={() => setShowAddQuestion(false)}>
                ×
              </button>
            </div>

            <div className="s-admin-feedback-modal-body">
              <div className="s-admin-feedback-form-field">
                <label>Question Type</label>
                <input type="text" placeholder="Select question type" />
              </div>

              <div className="s-admin-feedback-form-field">
                <label>Question Text</label>
                <textarea rows={3} placeholder="Enter your question..." />
              </div>

              <div className="s-admin-feedback-form-field">
                <label className="s-admin-feedback-checkbox-label">
                  <input type="checkbox" />
                  <span>Required question</span>
                </label>
              </div>
            </div>

            <div className="s-admin-feedback-modal-footer">
              <button className="s-admin-feedback-modal-btn s-admin-feedback-modal-btn-secondary" onClick={() => setShowAddQuestion(false)}>
                Cancel
              </button>
              <button className="s-admin-feedback-modal-btn s-admin-feedback-modal-btn-primary">Add Question</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormBuilder;
